<template>
<v-dialog
    v-model="dialog"
    fullscreen
    v-if="template_type != null"
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>All {{template_type.type_details.text}} Templates</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    dark
                    text
                    @click="onClickCancel"
                >
                    Cancel
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>

        

        <v-card-text
            style="padding-top: 15px"
        >

            <m-bulk-message-template-view-all-cards
                :template_type="template_type"
                v-on:create-message="onClickCreate"
            />

        </v-card-text>
        
    </v-card>
</v-dialog>
</template>

<script>
const _ = require('lodash');
export default {

    data() {
        return {
            dialog: false,
            last_dialog_guard: null,
            template_type: null,
            full_text: null,
        }
    },

    methods: {

        showDialog(template_type)
        {
            this.template_type = template_type;

            this.dialog = true;
            this.last_dialog_guard = this.$router.dialog_guard;
            this.$router.dialog_guard = this.dialogGuard;
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = this.last_dialog_guard;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.closeDialog();
                return;
            }
        
            this.closeDialog();
            next(false);
        },


        onClickCancel()
        {
            this.closeDialog();
        },

        wrapMessagePattern(src)
        {
            let ret = this.$rc.wrapHTML(src);

            return ret;
        },

        onClickCreate(item)
        {
            this.closeDialog();
            this.$emit('create', item)
        },
    },

    computed: {
        search_templates() {
            let ret = _.cloneDeep(this.template_type.templates);
            let search_text = (this.full_text ?? '').trim();
            
            if ( search_text == '' ) 
                return ret;

            ret = ret.filter(
                (item) => JSON.stringify(item).toLowerCase().includes(search_text.toLowerCase())
            );
            
            return ret;
        }
    },
}
</script>

<style lang="scss" scoped>
</style>